import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "h201ai6a",
  dataset: "production",
  useCdn: true,
  apiVersion: "2021-03-25",
});
